import { render, staticRenderFns } from "./teacher.vue?vue&type=template&id=7d8c455e&scoped=true"
import script from "./teacher.vue?vue&type=script&lang=js"
export * from "./teacher.vue?vue&type=script&lang=js"
import style0 from "./teacher.vue?vue&type=style&index=0&id=7d8c455e&prod&lang=scss&scoped=true"
import style1 from "./teacher.vue?vue&type=style&index=1&id=7d8c455e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8c455e",
  null
  
)

export default component.exports